import { createContext, useContext } from 'react';
import type { ApiClient } from '../utils/apiHuappsUtils';

export type ApiClientContextType = {
  AppApi: ApiClient;
  HuappsApi: ApiClient;
};

export const ApiClientContext = createContext<ApiClientContextType | null>(
  null,
);

export const useApiClients = (): ApiClientContextType => {
  const context = useContext(ApiClientContext);
  if (!context) {
    throw new Error('useApiClients must be used within ApiClientProvider');
  }
  return context;
};
